/**
 * The widget's own version, the one a host sees in vendor-pkg/package.json (BUILDING.md keeps the history). The usage
 * record's envelope carries it as `app_version` for the web widget and the desktop app's widget; test/usage-version.test.ts
 * fails when the two drift.
 */
export const GYRO_REACT_VERSION = '0.17.12';
//# sourceMappingURL=version.js.map